// extracted by mini-css-extract-plugin
module.exports = {"page":"error_page__jHoTS","page__body":"error_page__body__sJlOx","page__footer":"error_page__footer__NO8QK"};